<template>
  <div>
    <nav aria-label="breadcrumb" class="breadcrumb-nav">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="/"><i class="icon-home"></i></a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">{{ translations.login }}</li>
        </ol>
      </div>
      <!-- End .container -->
    </nav>
    <div class="page-header">
      <div class="container">
        <h1>{{ translations.loginRegisterTitle }}</h1>
      </div>
      <!-- End .container -->
    </div>
    <!-- End .page-header -->
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="heading">
            <h2 class="title">{{ translations.loginTitle }}</h2>
            <p>{{ translations.loginSubTitle }}</p>
          </div>
          <!-- End .heading -->
          <form @submit.prevent.stop="login()">
            <input
              type="text"
              id="username"
              class="form-control"
              :placeholder="translations.forms.labels.username"
              v-model="username"
            />
              <div class="password-wrapper">
                <input
                  :type="showPassword ? 'text' : 'password'"
                  class="form-control w-100"
                  :placeholder="translations.forms.labels.password"
                  v-model="password"
                />
                <div class="password-icon-wrapper">
                  <i
                    :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"
                    @click="togglePassword"
                  />
                </div>
              </div>
            <div class="form-footer">
              <button type="submit" class="btn btn-primary">{{ translations.loginButton }}</button>
              <router-link class="forget-pass" :to="{ name: 'ForgotPassword' }">
                {{ translations.forgotPassword }}
              </router-link>
            </div>
            <!-- End .form-footer -->
          </form>
        </div>
        <!-- End .col-md-6 -->
        <register @registered="focusUsernameInput" />
        <!-- End .col-md-6 -->
      </div>
      <!-- End .row -->
    </div>
    <!-- End .container -->
  </div>
</template>

<script>
import { translations } from '@/mixins';
import api from '@/services/api';
import Register from './Register.vue';

export default {
  name: 'Login',
  components: { Register },
  mixins: [translations],
  data() {
    return {
      username: '',
      password: '',
      showPassword: false,
    };
  },
  mounted() {
    const token = localStorage.getItem('token');
    const { query } = this.$route;

    const { redirectTo } = query;

    if (token && !redirectTo) {
      this.$router.push({ name: 'Home' });
    }

    if (token && redirectTo) {
      window.location.replace(redirectTo);
    }
  },
  methods: {
    login() {
      const { username, password } = this;
      api
        .login({ username, password })
        .then((response) => {
          const { query } = this.$route;
          const { redirectTo } = query;

          localStorage.setItem('token', response.data.token);
          this.$store.dispatch('getProfile');

          if (!redirectTo) {
            this.$router.push({ name: 'Home' });
          } else {
            window.location.replace(redirectTo);
          }

          this.$store.dispatch('storeProfileData', response.data);
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    focusUsernameInput() {
      document.getElementById('username').focus();
    },
  },
};
</script>
<style>
.password-wrapper {
  position: relative;
  width: 100%;
  max-width: 480px;
}

.password-icon-wrapper {
  position: absolute;
  display: flex;
  justify-content: flex-end;
  top: 15px;
  right: 15px;
  width: 20px;
}
</style>
